import React from "react";
import { MapPin, Phone, Mail } from "lucide-react";
import { PageHeader, Reveal, SectionHeading } from "@/components/public/ui";
import EnquiryForm from "@/components/public/EnquiryForm";
import { useSite } from "@/context/SiteContext";
import { toMapEmbed } from "@/lib/maps";

export default function Contact() {
  const { settings } = useSite();
  const cards = [
    { icon: Phone, label: "Call us", value: settings.phone, href: `tel:${(settings.phone || "").replace(/\s+/g, "")}` },
    { icon: Mail, label: "Email us", value: settings.email, href: `mailto:${settings.email}` },
    { icon: MapPin, label: "Visit us", value: settings.address },
  ];
  return (
    <div data-testid="contact-page">
      <PageHeader eyebrow="Contact Us" title="Let's talk clean helmets" subtitle="Request a demo, get a quote or ask us anything — our team responds quickly." />
      <section className="container-page py-24">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
          <div>
            <SectionHeading eyebrow="Get in touch" title="We'd love to hear from you" className="mb-8" />
            <div className="space-y-4">
              {cards.map((c, i) => (
                <Reveal key={i} delay={i * 0.06}>
                  <div className="flex items-center gap-4 rounded-2xl border border-slate-100 bg-white p-5 shadow-card">
                    <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-sky text-brand"><c.icon size={22} /></span>
                    <div>
                      <div className="text-xs uppercase tracking-wide text-muted-foreground">{c.label}</div>
                      {c.href ? <a href={c.href} className="font-600 text-brand-navy hover:text-brand">{c.value}</a> : <div className="font-600 text-brand-navy">{c.value}</div>}
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
            <div className="mt-6 overflow-hidden rounded-2xl border border-slate-100 shadow-card">
              <iframe title="Map" src={toMapEmbed(settings.map_embed, settings.address)} className="h-64 w-full" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
            </div>
          </div>
          <Reveal delay={0.1}>
            <EnquiryForm defaultInterest="Request a Demo" />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
